// A New dashboards board in the address bar as every other record is: a
// global id (base64 of "<type>:<id>", like "RGFzaGJvYXJkRGVmOjE2OA==" for a
// Metabase dashboard), not the bare number. The API keeps taking the number:
// the id is wrapped when a link is built and unwrapped where the page reads
// it, and a link that still carries the bare number keeps opening the board.
const TYPE = 'BuilderDashboardDef'

const unwrap = (value: string) => {
  try {
    const text = window.atob(value)
    return text.startsWith(`${TYPE}:`) ? text.slice(TYPE.length + 1) : value
  } catch {
    return value
  }
}

export const toBuilderGlobalId = (id: string | number) => {
  const raw = String(id)
  // The ':id' route placeholder, or an id that is already a global id.
  if (!raw || raw.startsWith(':') || unwrap(raw) !== raw) return raw
  return window.btoa(`${TYPE}:${raw}`)
}

export const fromBuilderGlobalId = (value: string) => unwrap(value)
